<template>
  <div class="w-full flex flex-col mx-auto col-span-3 md:col-span-1 bg-white shadow rounded-lg mb-6 md:opacity-80">
    <div class="flex-1">
      <div class="p-8 text-3xl font-bold border-b-4 h-auto">
        <img class="inline-block w-1/2 mb-4"
             :src="iconUrl"/>
        <br>
        {{planName}}
      </div>

      <ul v-if="features" class="text-sm lg:text-base">

        <li v-for="feature in features" class="border-b p-4">
          {{feature.text}}
          <strong>{{feature.subText}} </strong>
        </li>

      </ul>
    </div>
    <div v-if="planDesc" class="text-sm lg:text-base px-4 py-4">
      {{planDesc}}
    </div>
    <div class="flex-1 p-8">
      <p v-if="totalPrice" class="text-4xl font-bold mb-6">
        {{totalPrice}}
      </p>
      <p v-if="ctaLabel" class="mb-6">
        <a href="{{ config('app.url')}}/register"
           class="focus:outline-none shadow-lg rounded-md bg-blue-300 hover:bg-blue-200 text-black text-lg mt-5 py-3 px-10  font-bold mr-2 font-bold border-b-4 border-blue-500 hover:border-blue-300 rounded-full">
          {{ctaLabel}}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    iconUrl:String,
    planName: String,
    features: Array,
    ctaLabel: String,
    totalPrice: String,
    planDesc: String,
  },
  data() {
    return {};
  },
  beforeMount() {

  },
  created() {
  },
  setup(props, context) {
    return {}
  },

  methods: {},
  components: {},
};
</script>